<section class="pad">
    <div>
        <div>
           <p>

               You can make name changes on your certificates.
               This take less than 24 hours, and the modified certificate would be sent to your registered email address.
               Enter the policy number on the certificate and make sure to describe your modification, inputing all relevant changes in the comment box   
           </p> 
        </div>
        <div class="flex">
            <form class="sMbdrRad flex" [formGroup]="form" (ngSubmit)="submit()">
               <h3>
                    Kindly fill below form
               </h3> 
               <mat-form-field>
                    <mat-label>Policy Number</mat-label>
                    <input formControlName="policyNumber" type="text" matInput>
                </mat-form-field>
                <mat-form-field>
                    <mat-label>Describe your request here</mat-label>
                    <textarea formControlName="comment" matInput name="" id="" cols="20" rows="5"></textarea>
                </mat-form-field>
                <button mat-raised-button [disabled]="!form.valid" type="submit"> <mat-icon>send</mat-icon> Submit Request</button>
            </form>
        </div>
    </div>
</section>